import Cookies from 'js-cookie';

function utm() {
    if (window.location.href.indexOf('utm_source') === -1) {
        return;
    }

    const cookieUtm = Cookies.get('utm');
    const currentUtm = getURLParameter('utm_source');

    if (cookieUtm && cookieUtm === currentUtm) {
        return;
    }

    Cookies.set('utm', getURLParameter('utm_source'));
}

function getURLParameter(name) {
    return (
        decodeURIComponent((new RegExp(`[?|&]${name}=` + `([^&;]+?)(&|#|;|$)`).exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null
    );
}

document.addEventListener('DOMContentLoaded', () => {
    utm();
});
